// Marker.js
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
//import Boop2 from 'components/Boop/Boop2';
//import ReactTooltip from 'react-tooltip';

const Wrapper = styled.div`
    position: absolute;
    width: 38px;
    height: 37px;
    background-image: url(https://icon-library.com/images/pin-icon-png/pin-icon-png-9.jpg);
    background-size: contain;
    background-repeat: no-repeat;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    cursor: grab;
    transition: transform .2s;
    &:hover {
       transform: scale(1.2) translate(-50%,-50%);
       span {
        visibility: visible
       }
                
    }

`;

const ToolTipText = styled("span")({
    visibility: "hidden",
    width: "120px",
    backgroundColor: "#000",
    color: "#fff",
    textAlign: "center",
    borderRadius: "6px",
    padding: "5px 0",
    position: "absolute",
    zIndex: 1,
    bottom: "100%",
    left: "50%",
    marginLeft: "-60px",
    ":after": {
      content: '""',
      position: "absolute",
      top: "100%",
      left: "50%",
      marginLeft: "-5px",
      borderWidth: "5px",
      borderStyle: "solid",
      borderColor: "black transparent transparent transparent"
    }
  });

function Marker ({ text, onClick, toolTipObj }) {

    const handleClick = () => {
        onClick(text);
    }

    return(
        <Wrapper alt={text} onClick={handleClick} >
            <ToolTipText>
                {toolTipObj.name}<br/>
                {toolTipObj.dev_eui}
            </ToolTipText>

        </Wrapper>
    )

}

Marker.defaultProps = {
    onClick: null,
    tooltiptext: "This is a tooltip",
};

Marker.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
    toolTipObj: PropTypes.object,
};

export default Marker;